(function() {
  let cookieName = 'cart_cleared';

  function getCookie(name) {
    return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
  }

  function setCookie(name, value) {
    document.cookie = name + "=" + value + "; path=/";
  }

  if (!getCookie(cookieName)) {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(response) {
        if (response.ok) {
          setCookie(cookieName, 'true');
          console.log('Cart Cleared');
        }
      });
  }
})();
